interface ClientName {
    code?: string;
    razon_social?: string;
  }
  
  export function getClientName(client?: ClientName | null): string {
    if (client?.code && client?.razon_social) return `${client.code} - ${client.razon_social}`;
    if (client?.code) return client.code;
    return client?.razon_social ?? '';
  }
  